import React from 'react';

import Range from 'components/Range';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { getFormattedPrice } from 'utils/currency';

import { Container, RangeArea, ValuesArea, Value } from './styles';

interface Props {
  min: number;
  max: number;
  currency: string;
  value?: number[];
  onChange: (value: number[]) => void;
}

const Price = ({ currency, ...props }: Props) => {
  const { t } = useStoreTranslation();
  const formattedPrice = (value: number | undefined) => {
    const { formatted } = getFormattedPrice({ value, currency, t });
    return formatted;
  };
  const { min, max, value } = props;

  return (
    <Container>
      <RangeArea>
        <Range {...props} step={0.01} />
      </RangeArea>
      <ValuesArea>
        <Value>{formattedPrice(value?.length ? value?.first() : min)}</Value>
        <Value>{formattedPrice(value?.length ? value?.last() : max)}</Value>
      </ValuesArea>
    </Container>
  );
};

export default Price;
